<template>
  <div class="home">
    <topmenu @refresh="refresh"/>

    <section class="section">
      <div class="container">
        <b-field label="Змінити день">
          <b-datepicker v-model="date"
              :month-names="$store.state.month"
              @input="refresh"
              :first-day-of-week="1"
              placeholder="Змінити дату">

              <button class="button is-primary"
                  @click="date = new Date()">
                  <b-icon icon="calendar-today"></b-icon>
                  <span>Сегодня</span>
              </button>
          </b-datepicker>
        </b-field>

        <div>
          <b-table :data="result" :columns="columns"></b-table>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
import topmenu from "@/components/menu.vue";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      data: {},
      date: new Date(),
      columns: [
          {
              field: 'sum_all',
              label: 'Сума всіх замовлень'
          },
          {
              field: 'debt',
              label: 'Борг за сьогодні'
          },
          {
              field: 'orev_debt',
              label: 'Борг за минулі дні'
          },
          {
              field: 'pain_cart',
              label: 'Оплата карткою'
          },

          {
              field: 'pain_bonus',
              label: 'Оплата бонусами'
          },
          {
              field: 'costs',
              label: 'Витрати з каси'
          },
      ]
    };
  },
  methods: {
    ...mapActions(["getAccounting", 'addAccounting']),
    refresh() {
      this.submit()
    },
    async submit() {
      await this.addAccounting({
        date: this.today
      }).then((result) => {
        console.log(result)
        this.data = result
      })
    }
  },
  computed: {
    today() {
      var today = this.date;
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
      return `${yyyy}-${mm}-${dd}`;
    },
    result() {
      if (Object.keys(this.data).length == 0) return;
      const x = this.data
      return [
        { 
          'sum_all': x.all.sum,
          'debt': x.debt.sum,
          'orev_debt': x.prev_debt.sum,
          'pain_cart': `${x.paid.cc.sum} - ${x.paid.cc.sum_with_tax}`,
          'pain_bonus': x.paid.bonuses.sum,
          'costs': x.costs.sum
        },
      ]
    }
  },
  mounted() {
    this.refresh();
  },
  components: {
    topmenu
  }
};
</script>

<style lang="scss" scoped>
.flex {
  justify-content: space-between;
  & > div {
    padding: 0 10px;
  }
}
@media only screen and (max-width: 768px) {
  .flex {
    flex-direction: column;
  }
}
</style>


